import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Puedo hacerlo sin equipo de gimnasio?',
    a: 'Sí, absolutamente. El plan de fuerza está diseñado para hacerse en casa con tu propio peso corporal, una silla y (opcionalmente) un par de mancuernas ligeras o botellas de agua.'
  }, {
    q: '¿Y si tengo dolor articular?',
    a: 'El protocolo incluye modificaciones de bajo impacto. Siempre priorizamos el movimiento seguro sobre la intensidad. Si tienes una lesión específica, consulta a tu médico.'
  }, {
    q: '¿Tengo que dejar el café?',
    a: 'No. Solo ajustaremos los horarios para que no interfiera con tu cortisol y sueño, que son clave para desinflamar.'
  }, {
    q: '¿Qué hago si me estanco?',
    a: "El programa incluye una sección específica sobre 'estancamientos' y cómo ajustar las 3 palancas (proteína, fuerza, sueño) para volver a ver progreso."
  }, {
    q: '¿Cuándo recibo el PDF?',
    a: 'Inmediatamente después de tu compra recibirás un correo electrónico con el enlace de descarga segura.'
  }];
  return <section className="py-20 bg-[#F5F0E8]" data-id="element-1">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-2">
        <h2 className="text-3xl lg:text-4xl font-serif font-bold text-center text-[#3D4852] mb-12" data-id="element-3">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-4">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl overflow-hidden shadow-sm" data-id="element-5">
              <button className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-6">
                <span className="font-bold text-[#3D4852]" data-id="element-7">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-[#C17F6B]" data-id="element-8" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-9" />}
              </button>

              {openIndex === index && <div className="px-6 pb-6 text-gray-600 animate-in slide-in-from-top-2 duration-200" data-id="element-10">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}